let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jILNp")).then(() => parcelRequire('fQBAE'));